import { motion } from "framer-motion";

// U-TOPIA hero film — Vimeo embed (autoplay, muted, looping) using the
// exact embed code + unlock hash provided by the client.
export default function HeroVideo() {
  const src =
    "https://player.vimeo.com/video/1229443916" +
    "?h=7857c34046&badge=0&autopause=0&player_id=0&app_id=58479";

  return (
    <section
      id="watch"
      className="relative pt-24 lg:pt-28 pb-6 lg:pb-10 overflow-hidden"
    >
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 h-[520px] w-[900px] rounded-full bg-flame/[0.10] blur-[80px] pointer-events-none" />

      <div className="mx-auto max-w-7xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-3 mb-5"
        >
          <span className="font-mono text-flame text-xs tracking-[0.3em]">FILM</span>
          <span className="h-px w-16 bg-white/10" />
          <span className="font-mono text-white/40 text-[0.65rem] tracking-[0.25em] uppercase">
            U-topia Investment Pitch
          </span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="absolute -inset-6 rounded-[28px] bg-flame/15 blur-3xl opacity-70 pointer-events-none" />

          <div
            className="relative w-full overflow-hidden rounded-2xl border border-white/10 shadow-[0_40px_100px_-30px_rgba(0,0,0,0.6)] bg-navy"
            style={{ paddingTop: "56.25%" }}
          >
            <iframe
              data-testid="hero-video-iframe"
              src={src}
              title="U-topia Investment Pitch"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              className="absolute inset-0 h-full w-full"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
